import styles from './filter.module.scss';
import FilterSection from './filterSection';
import FilterSelect from './filterSelect';
import { ReactComponent as ResetIcon } from '../../static/icon-reset.svg';
import {
  activeFiltersActions,
  FilterOption,
  useActiveFilters
} from '../../context/active-filter-context';

const Filter = () => {
  const { state, dispatch } = useActiveFilters();

  return (
    <div className={styles.filters}>
      <form className={styles.filters}>
        <div className={styles.sectionOutline}>
          <FilterSection label="Filter by partner" htmlFor="filter-partner">
            <FilterSelect
              dataTestId="PT-filter-partnerSelect"
              options={state.partnerOptions.options}
              defaultOption={state.filters.PARTNER}
              name="partner"
              value={state.filters.PARTNER}
              onChange={e => {
                dispatch(activeFiltersActions.setFilter('PARTNER', e as FilterOption));
              }}
            />
          </FilterSection>
        </div>

        <div className={styles.sectionOutline}>
          {state.count ? (
            <button
              data-testid="PT-filter-resetFiltersButton"
              className={styles.btnReset}
              onClick={() => {
                dispatch(activeFiltersActions.resetFilters());
              }}
            >
              <ResetIcon className={styles.iconReset} /> Reset
            </button>
          ) : null}
        </div>
      </form>
    </div>
  );
};

export default Filter;
